// extracted by mini-css-extract-plugin
module.exports = {"specialProject":"styles_specialProject__PCgHj","imageOverlay":"styles_imageOverlay__MvHgD","title":"styles_title__sfes6"};